import { useCallback } from 'react';
import type { PermissionKey } from '@repo/domain';

import { ROLE_PERMISSIONS } from '@features/auth/constants/rolePermissions';
import { useHeldRolesStore } from '@features/auth/stores/useHeldRolesStore';
import type { CanFunction, PermissionTarget } from '@features/auth/types';
import { holdsPermission } from '@features/auth/utils/holdsPermission';

/**
 * Returns `can(permission, target?)` for the signed-in person, built on the roles from their access
 * token and the copied permission contract. It decides what the UI offers only — the backend checks
 * every permission again on each request. Answers `false` while the roles are not known yet.
 */
export function useCan(): CanFunction {
  const heldRoles = useHeldRolesStore((state) => state.heldRoles);

  return useCallback(
    (permission: PermissionKey, target?: PermissionTarget): boolean =>
      holdsPermission({ heldRoles, permission, target, rolePermissions: ROLE_PERMISSIONS }),
    [heldRoles]
  );
}
